import { Me, PostSetSchoolRequest } from '../../../typings';
import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function postSetSchool(schoolData: PostSetSchoolRequest): Promise<Me> {
    const { apiPostSetSchool } = apiConfig.getStaticUrls();

    return postFetch(apiPostSetSchool, schoolData);
}
